
const removebundle = {

    removeItemsFromCart: (elems) => {
        let formData = removebundle.itemsData(elems);

        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                document.dispatchEvent(new CustomEvent('cart:build'))
                document.dispatchEvent(new CustomEvent('cart:bundle-updated'));
                document.dispatchEvent(new CustomEvent('cart:updated', {
                    detail: {
                        cart: data
                    }
                }));            })
        .catch((error) => {
            console.error('Error:', error);

        });
      
    },
    itemsData: (elems) => {
        let data = {}
        const ids = [...elems].map(item => item.dataset.lineId);

        ids.forEach(id => {
            data[id] = 0;
        });

        return { updates: data };
    },
    init: () => {
        document.addEventListener('click', (event) => {

            // Make sure, that you're receiving event from a correct element
            if (event.target.dataset.action === 'remove-sub-bundle')
            {
                event.preventDefault();
                if (confirm(theme.strings.removeBundleAlert))
                {
                  
                    const bundleProducts = document.querySelectorAll('[data-action*="remove-sub-bundle"]')
                    if (!bundleProducts) return

                    const matchingProducts = [...bundleProducts].filter(x => x.dataset.bundleId == event.target.dataset.bundleId);
                    removebundle.removeItemsFromCart(matchingProducts)
                }
            }
            else if (event.target.dataset.action === 'remove-bundle')
            {
                event.preventDefault();
                if (confirm(theme.strings.removeBundleAlert))
                {
                  
                    const bundleProducts = document.querySelectorAll('[data-action*="remove-sub-bundle"],[data-action*="remove-bundle"]')
                    if (!bundleProducts) return

                    const matchingProducts = [...bundleProducts].filter(x => x.dataset.bundlePatternId == event.target.dataset.bundlePatternId);
                    removebundle.removeItemsFromCart(matchingProducts)
                }
            }
        });

    }
}


document.addEventListener("DOMContentLoaded", function() {
    removebundle.init();
});
